// @ts-nocheck
import client from "../../utils/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { VisitorAdminVisitorSignOutMutationResponse, VisitorAdminVisitorSignOutPathParams, VisitorAdminVisitorSignOut401, VisitorAdminVisitorSignOut406, VisitorAdminVisitorSignOut409 } from "../models/VisitorAdminVisitorSignOut";
import type { UseMutationOptions } from "@tanstack/react-query";

 type VisitorAdminVisitorSignOutClient = typeof client<VisitorAdminVisitorSignOutMutationResponse, VisitorAdminVisitorSignOut401 | VisitorAdminVisitorSignOut406 | VisitorAdminVisitorSignOut409, never>;
type VisitorAdminVisitorSignOut = {
    data: VisitorAdminVisitorSignOutMutationResponse;
    error: VisitorAdminVisitorSignOut401 | VisitorAdminVisitorSignOut406 | VisitorAdminVisitorSignOut409;
    request: never;
    pathParams: VisitorAdminVisitorSignOutPathParams;
    queryParams: never;
    headerParams: never;
    response: VisitorAdminVisitorSignOutMutationResponse;
    client: {
        parameters: Partial<Parameters<VisitorAdminVisitorSignOutClient>[0]>;
        return: Awaited<ReturnType<VisitorAdminVisitorSignOutClient>>;
    };
};
/**
 * @summary 签退访客
 * @link /api/v5/admin/visitors/:id/sign-out
 */
export function useVisitorAdminVisitorSignOut(options: {
    invalidationOnSuccess?: boolean;
    mutation?: UseMutationOptions<VisitorAdminVisitorSignOut["response"], VisitorAdminVisitorSignOut["error"], {
        id: VisitorAdminVisitorSignOutPathParams["id"];
        data?: VisitorAdminVisitorSignOut["request"];
    }>;
    client?: VisitorAdminVisitorSignOut["client"]["parameters"];
} = {}) {
    const { mutation: mutationOptions, client: clientOptions = {} } = options ?? {};
    const queryClient = useQueryClient();
    let invalidationOnSuccessOption = options?.invalidationOnSuccess ?? true;
    return useMutation({
        mutationFn: async ({ id }) => {
            const res = await client<VisitorAdminVisitorSignOut["data"], VisitorAdminVisitorSignOut["error"], VisitorAdminVisitorSignOut["request"]>({
                method: "patch",
                url: `/api/v5/admin/visitors/${id}/sign-out`,
                ...clientOptions
            });
            return res.data;
        },
        ...mutationOptions,
        onSuccess: (...args) => {
            if (invalidationOnSuccessOption) {
                queryClient.invalidateQueries({
                    queryKey: ["api", "v5", "admin", "visitors"]
                });
            }
            if (mutationOptions?.onSuccess)
                mutationOptions.onSuccess(...args);
        },
    });
}